import { useLayoutEffect, useMemo, useRef, useState } from "react";

/**
 * For static data, virtualization returns empty array of items
 * It happens because virtualization is initialized before the table wrapper ref is available
 * This hook is used to rerender virtualization when the table wrapper ref is available
 */
const useTableVirtualizationRef = () => {
  const tableWrapperRef = useRef<HTMLDivElement>(null);

  // Use useState to trigger re-renders when DOM element is available
  const [tableElement, setTableElement] = useState<HTMLDivElement | null>(null);

  // Sync the ref state when tableRef becomes available
  useLayoutEffect(() => {
    if (tableWrapperRef.current && tableWrapperRef.current !== tableElement) {
      setTableElement(tableWrapperRef.current);
    }
  }, [tableElement]);

  // Create virtualization-aware ref that triggers re-renders
  const virtualizationRef = useMemo(() => ({ current: tableElement }), [tableElement]);

  return {
    tableWrapperRef,
    virtualizationRef,
  };
};

export default useTableVirtualizationRef;
